$(document).ready(function(){
  var headerHeight = $('header').outerHeight(),
          lastScrollTop = 0;
      $(window).scroll(function (event) {
         var st = $(this).scrollTop();
        if (st > lastScrollTop) {
          if (st > 0) {
              $('header').addClass('remove_logo');
              if(st > headerHeight){
                $('header').removeClass('remove_logo');
              }
          }
          else {
            $('header').removeClass('remove_logo');
          }
        } else {
          $('header').removeClass('remove_logo');
        }
        lastScrollTop = st;
      })

   


  $('.play-icon > button#pausePlay').click(function(){
    $("#ytvideo").addClass("hide_placeholder");
  });

  $("a").on('click', function(event) {
  var href = $(this).attr('href');
  if (this.hash !== "" && href && !href.startsWith('/#')) {
    event.preventDefault();
    var hash = this.hash;
    $('html, body').animate({
      scrollTop: $(hash).offset().top
    }, 1000, function(){
      window.location.hash = hash;
    });
  }
});

$('#menu-drawer').find('.menu-drawer__navigation ul li').children("a").on('click', function(event) {
    var href = $(this).attr('href');
    if (this.hash !== "" && href && !href.startsWith('/#')) {
        event.preventDefault();
        if($('.menu-drawer-container').hasClass('menu-opening')){
            $('.menu-drawer-container').removeClass('menu-opening')
        }
      }
});
  $('.image-text-slider').owlCarousel({
            items: 1,
            loop: false,
            margin: 0,
            nav: true,
            smartSpeed: 800,
        })
  $(window).paroller();





const anchor = document.getElementsByClassName('btn');

if (anchor.textContent === "CATERING PACKAGE") {
  anchor.classList.add('trigger-popup');
}

  
const el = document.getElementsByClassName('btn');

// The condition
if(someCondition) {

  // Add the class
  el.classList.add('trigger-popup');

}

     desktopVideo.play();
    tabletVideo.play();  
  // var winHeight = $(window).height();
  // console.log(winHeight);

  // if ( $('.video-banner').offset().top == 0 ) {
  //     console.log('abc');
  // }


  // Limitation: Does not work if the element is
// out of view because it is too far right or left
// $.fn.isInViewport = function() {
//     var elementTop = $(this).offset().top;
//     var elementBottom = elementTop + $(this).outerHeight();

//     var viewportTop = $(window).scrollTop();
//     var viewportBottom = viewportTop + $(window).height();

//     return elementBottom > viewportTop && elementTop < viewportBottom;
// };

// //setInterval(function() {
//     $('iframe').each(function(){

//         let id = $(this).attr("id");

//         //let played = $(this).attr("played");

//         if ($(this).isInViewport()) {
//                 console.log("true- ",id);
//           playVideo();
//             // if (played == "false") { 
//             //   playVideo();
//             //     $(this)[0].play();
//             //     $(this).attr("played", "true");  
//             // }
//         } else {
//           console.log("false- ",id);
//           pauseVideo();
//             // if (played == "true") { 

//             //   pauseVideo();
//             //     $(this)[0].pause();
//             //     $(this).attr("played", "false");  
//             // }
//         }
//     });
// //}, 1000);
})